'use client';

import dynamic from 'next/dynamic';

// @vis.gl/react-google-maps is ~41 KiB — wrap in a client component so
// `ssr: false` is allowed and the chunk is only fetched when a listing
// actually includes a Google Map widget.
const GoogleMapView = dynamic(
  () =>
    import('./map-view').then(mod => ({
      default: mod.GoogleMapView,
    })),
  { ssr: false },
);

export { GoogleMapView as LazyGoogleMapView };
